import React, {Fragment, useState} from 'react';
import {sendRequest} from '../../utils/request';
import isEqual from 'lodash-es/isEqual';
import config from "../../config/config";
import axios from "axios";
import PropTypes, {object} from "prop-types";
import classNames from 'classnames';
import {get, set} from "../../utils/dotutils";
import {list} from "../../utils/array";
import debounce from "../../utils/debounce";
import {empty} from "locutus/php/var";
import ComponentConfig from "./ComponentConfig";
import {optionsTemplate} from "../../utils/formatters";
import CheckBox from "./CheckBox";

function removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
}

const lastRequests = {};

class SelectComp extends React.Component {

    state = {
        isLoading: false,
        fullcount: null,
        optionIsLoading: false,
        options: [],
        usedoptions: [],
        isFocused: false,
        pageSize: config.defaultPageSize
    };

    optionsLoaded = async (options = [], listparams = null, queryParams = null, fullcount = null) => {
        listparams = listparams || {
            optionname: this.props.optionname
        };
        queryParams = queryParams || {
            labelKey: this.state.labelKey,
            valueKey: this.state.valueKey,
        }
        const onLoadCompleted = async (options) => {
            if (this.props.onLoadCompleted) {
                let newOptions = await this.props.onLoadCompleted(options);
                if (Array.isArray(newOptions)) {
                    return newOptions;
                }
            }
            return options;
        }
        options = await onLoadCompleted(options);
        // TODO ezt azért majd ha az option language stb össze van rakva ki kéne venni
        if (listparams.optionname) {
            options = removeDuplicates(options, "optionid");
        }
        const changed = JSON.stringify(options) !== JSON.stringify(this.state.options);
        this.setState({
            labelKey: queryParams.labelKey,
            valueKey: queryParams.valueKey,
            optionIsLoading: false,
            options,
            fullcount
        });
    }

    isRemote = () => this.props.storeType === "remote" || (this.props.storeType === "local" && (this.props.options === undefined || this.props.options === null));

    constructor(props) {
        super(props);
        this.loadOptions = debounce(async (listparams = null, options = []) => {
            if (this.isRemote()) {
                this.setState({optionIsLoading: true});
                this.lastOptionRequest && this.lastOptionRequest.abort();
                const queryParams = await this.generateQueryParams(this.props, this.state);
                const listparams = listparams || queryParams.listparams;
                if (!listparams) {
                    this.optionsLoaded(options, listparams, queryParams);
                } else {
                    if (options.length) {
                        listparams.filter = list(listparams.filter, {field: queryParams.valueKey, value: options.map((v) => {
                                if (typeof (v) === "object" && v) {
                                    return v[queryParams.valueKey];
                                }
                                return v;
                            }),
                            operator: "not in"
                        })
                    }
                    const key = JSON.stringify(listparams);
                    if (lastRequests[key]) {
                        this.lastOptionRequest = lastRequests[key];
                    } else {
                        lastRequests[key] = this.lastOptionRequest = sendRequest(listparams, {url: this.props.url});
                    }
                    this.lastOptionRequest.then(async (data) => {
                        delete lastRequests[key];
                        this.optionsLoaded([...options, ...(data.items || [])], listparams, queryParams, data.fullcount);
                    });
                    const abort = this.lastOptionRequest.abort;
                    this.lastOptionRequest.abort = () => {
                        abort();
                        delete lastRequests[key];
                    }
                }
            } else {
                this.optionsLoaded(this.props.options || []);
            }
        }, 300);
    }

    loadValues = async (listparams) => {
        this.lastrequest && this.lastrequest.abort();
        if (this.isRemote()) {
            this.setState({isLoading: true});
            if (!this.props.options) {
                let queryParams = await this.generateQueryParams(this.props, this.state, this.props.value === false ? null : this.props.value);
                const listparams = listparams || queryParams.listparams;
                if (!listparams) {
                    this.setState({
                        isLoading: false,
                        usedoptions: []
                    });
                } else {
                    const props = this.props;
                    const valueKey = queryParams.valueKey;
                    let value = props.value;
                    if (props.isMulti) {
                        if (!Array.isArray(value)) {
                            if (value) {
                                value = [value];
                            } else {
                                value = [];
                            }
                        }
                        if (value.length) {
                            if ((props.objectValue === undefined || props.objectValue === true) && typeof (value[0]) !== "object") {
                                const values = [...(props.options || this.state.options), ...this.state.usedoptions];
                                if (values.length > 0) {
                                    value = removeDuplicates(values, valueKey).filter((option) => value.indexOf(option[valueKey]) !== -1).map((option) => option[valueKey]);
                                }
                            } else if (typeof (value[0]) === "object") {
                                value = value.map((v) => v[valueKey]);
                            }
                        }
                    } else {
                        if ((props.objectValue === undefined || props.objectValue === true) && typeof (value) !== "object") {
                            const values = [...(props.options || this.state.options), ...this.state.usedoptions];
                            if (values.length > 0) {
                                value = (removeDuplicates(values, valueKey).find((option) => option[valueKey] == value) || {});
                            }
                        }
                        value = typeof (value) === 'object' && value !== null && value !== undefined ? (value[valueKey] || null) : (value !== null && value !== undefined ? (value || null) : null);
                    }

                    if (Array.isArray(value)) {
                        if (value && value.length) {
                            listparams.filter = [{field: queryParams.valueKey, value: value, operator: "in"}];
                        }
                    } else {
                        if (value) {
                            listparams.filter = [{field: queryParams.valueKey, value: value}];
                        }
                    }
                    const key = JSON.stringify(listparams);

                    if (lastRequests[key]) {
                        this.lastrequest = lastRequests[key];
                    } else {
                        lastRequests[key] = this.lastrequest = sendRequest(listparams, {url: this.props.url});
                    }
                    this.lastrequest.then((data) => {
                        delete lastRequests[key];
                        this.setState({
                            labelKey: queryParams.labelKey,
                            valueKey: queryParams.valueKey,
                            isLoading: false,
                            usedoptions: [...(data.items || [])],
                        });
                    }).catch((e) => {
                        delete lastRequests[key];
                        if (!(e instanceof axios.Cancel) && e.message) {
                            console.log(e);
                            this.setState({
                                labelKey: queryParams.labelKey,
                                valueKey: queryParams.valueKey,
                                isLoading: false,
                                usedoptions: []
                            });
                        }
                    });
                }
            } else {
                this.setState({isLoading: false, usedoptions: []});
            }
        } else {
            this.setState({isLoading: false, usedoptions: []});
        }
    }

    componentDidMount() {
        if (this.props.focus || this.props.autoFocus) {
            this.focus();
        }
        this.componentDidUpdate({}, {}, {});
    }

    refresh = () => {
        this.componentDidUpdate({}, {}, {});
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const current = this.generateQueryParams(this.props, this.state);
        const prev = this.generateQueryParams(prevProps, prevState);
        const sameValue = JSON.stringify(this.props.value) === JSON.stringify(prevProps.value)
        const call = () => {
            if (!sameValue) {
                this.loadValues(current);
            }
            this.loadOptions(current);
        }
        if (!isEqual(current, prev) || !sameValue) {
            if (current) {
                this.setState({
                    labelKey: current.labelKey,
                    valueKey: current.valueKey,
                }, call);
            } else {
                call();
            }
        } else if (!this.state?.valueKey) {
            this.setState({
                labelKey: current?.labelKey,
                valueKey: current?.valueKey,
            });
        }
        const prevFocus = prevProps.focus || prevProps.autoFocus;
        const focus = this.props.focus || this.props.autoFocus;
        if (prevFocus !== focus && focus) {
            this.focus();
        }
    }

    componentWillUnmount() {
        //this.lastrequest && this.lastrequest.abort();
        //this.lastOptionRequest && this.lastOptionRequest.abort();
    }

    getOptionsTemplate = () => {
        if (this.props.component) {
            return this.props.optionsTemplate || optionsTemplate(this.props.component);
        } else {
            return this.props.optionsTemplate;
        }
    }

    generateQueryParams = (props, state, values = false) => {
        if (values !== false && empty(values)) {
            return {listparams: undefined, valueKey: undefined, labelKey: undefined, prepared: false};
        }
        let valueKey = props.valueKey || (props.optionname ? 'optionid' : 'id');
        let labelKey = props.labelKey || (props.optionname ? 'optionlabel' : 'label');

        const componentConfig = props.componentConfig;
        const targetConfig = props.targetConfig;
        if (!props.labelKey) {
            // TODO adapter fielddefs
            if (componentConfig?.namefield) {
                labelKey = componentConfig?.namefield;
            } else if (componentConfig?.fielddefs?.name) {
                labelKey = "name";
            } else if (componentConfig?.fielddefs?.title) {
                labelKey = "title";
            } else if (componentConfig?.fielddefs?.label) {
                labelKey = "label";
                // decorator config field
            } else if (targetConfig?.namefield) {
                labelKey = targetConfig?.namefield;
            } else if (targetConfig?.fielddefs?.name) {
                labelKey = "name";
            } else if (targetConfig?.fielddefs?.title) {
                labelKey = "title";
            } else if (targetConfig?.fielddefs?.label) {
                labelKey = "label";
            }
        }
        if (!props.valueKey) {
            valueKey = componentConfig?.idfield;
        }
        valueKey = valueKey || (props.optionname ? 'optionid' : 'id');
        labelKey = labelKey || (props.optionname ? 'optionlabel' : 'label');

        const listparams = {
            option: "componentlist",
            matchmode: props.matchmode || "any",
            component: props.component || "option",
            group: props.groupBy,
            order: props.order,
            itemsperpage: props.storeType && props.storeType === "local" ? 0 : props.limit || this.state.pageSize || config.defaultPageSize,
        };
        if (props.listfield) {
            listparams.listfield = props.listfield;
        }
        if (props.optioncomponent) {
            listparams.optioncomponent = props.optioncomponent;
        }
        if (!props.component) {
            listparams.optionname = props.optionname;
        } else if (!componentConfig) {
            return {listparams: undefined, valueKey, labelKey, prepared: false};
        }

        listparams.filter = list(props.filter);

        if (!empty(listparams.order)) {
            listparams.order = list(listparams.order);
            if (!listparams.order.find((order) => (order.field || "") === labelKey)) {
                listparams.order.push({field: labelKey, direction: "ASC"});
            }
        } else {
            listparams.order = {field: labelKey, direction: "ASC"};
        }

        listparams.parameters = props.parameters || undefined;
        listparams.view = props.view || undefined;

        // TODO undefined view to default!!!
        const template = this.getOptionsTemplate();
        if (template) {
            if (template instanceof Object) {
                let templateView = template.view || [];
                if (Array.isArray(listparams.view)) {
                    if (Array.isArray(templateView)) {
                        listparams.view = [...listparams.view, ...templateView];
                    } else if (templateView instanceof Object) {
                        const view = listparams.view;
                        listparams.view = {};
                        view.map((v) => listparams.view[v] = "");
                        listparams.view = {...listparams.view, ...templateView};
                    } else {
                        console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                    }
                } else if (listparams.view instanceof Object) {
                    if (Array.isArray(templateView)) {
                        const view = templateView;
                        templateView = {};
                        view.map((v) => templateView[v] = "");
                        listparams.view = {...listparams.view, ...templateView};
                    } else if (templateView instanceof Object) {
                        listparams.view = [...listparams.view, ...templateView];
                    } else {
                        console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                    }
                } else if (!listparams.view && templateView) {
                    listparams.view = templateView;
                } else if (!!listparams.view && !templateView) {
                    // nothing to do
                } else {
                    console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                }
            }
        }

        if (props.selectedOptionTemplate) {
            const template = props.selectedOptionTemplate;
            if (template instanceof Object) {
                let templateView = template.view || [];
                if (Array.isArray(listparams.view)) {
                    if (Array.isArray(templateView)) {
                        listparams.view = [...listparams.view, ...templateView];
                    } else if (templateView instanceof Object) {
                        const view = listparams.view;
                        listparams.view = {};
                        view.map((v) => listparams.view[v] = "");
                        listparams.view = {...listparams.view, ...templateView};
                    } else {
                        console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                    }
                } else if (listparams.view instanceof Object) {
                    if (Array.isArray(templateView)) {
                        const view = templateView;
                        templateView = {};
                        view.map((v) => templateView[v] = "");
                        listparams.view = {...listparams.view, ...templateView};
                    } else if (templateView instanceof Object) {
                        listparams.view = [...listparams.view, ...templateView];
                    } else {
                        console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                    }
                } else if (!listparams.view && templateView) {
                    listparams.view = templateView;
                } else if (!!listparams.view && !templateView) {
                    // nothing to do
                } else {
                    console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                }
            }
        }

        if (Array.isArray(listparams.view)) {
            if (listparams.view.indexOf(valueKey) === -1) {
                listparams.view.push(valueKey);
            }
            if (listparams.view.indexOf(labelKey) === -1) {
                listparams.view.push(labelKey);
            }
            const listview = listparams.view;
            listparams.view = {};
            listview.map((field) => {
                set(listparams.view, field, "");
            });
        } else if (listparams.view instanceof Object) {
            if (!listparams.view[valueKey]) {
                set(listparams.view, valueKey, get(listparams.view, valueKey) || "");
            }
            if (!listparams.view[labelKey]) {
                set(listparams.view, labelKey, get(listparams.view, labelKey) || "");
            }
        } else if(props.objectValue === false) {
            listparams.view = {};
            set(listparams.view, valueKey, "");
            set(listparams.view, labelKey, "");
        } else {
            listparams.view = listparams.view || [valueKey,labelKey];
            if (Array.isArray(listparams.view)) {
                const listview = listparams.view;
                listparams.view = {};
                listview.map((field) => {
                    set(listparams.view, field, "");
                });
            }
        }
        return {listparams, valueKey, labelKey, prepared: true};
    }

    handleChange = async (selected, actionMeta) => {
        actionMeta = actionMeta || {action: "select-option", name: this.props.name, option: undefined};
        let value = await this.returnValueParser(selected);
        if (this.props.onSelect) {
            this.props.onSelect(value);
        }
        if (this.props.saveChanges) {
            this.props.saveChanges(
                this.props.name,
                value,
                new CustomEvent(actionMeta.action, {
                    detail: actionMeta
                })
            );
        }
        this.setState({pageSize: config.defaultPageSize, fullcount: null}, async () => {
            await this.loadValues();
            this.loadOptions();
        });
    }

    returnValueParser = async (value) => {
        const valueKey = this.props.valueKey || this.state.valueKey;
        if (this.props.isMulti) {
            value = list(value);
            if (value.length) {
                value = value.map((v) => {
                    if (typeof (v) === "object" && v) {
                        return v[valueKey];
                    }
                    return v;
                });
                if ((this.props.objectValue === undefined || this.props.objectValue === true)) {
                    value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).filter((option) => value.indexOf(option[valueKey]) !== -1);
                }
            }
        } else {
            if ((this.props.objectValue === undefined || this.props.objectValue === true) && typeof (value) !== "object") {
                value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).find((option) => option[valueKey] == value);
            } else if(this.props.objectValue === false && typeof (value) === "object") {
                if (value !== null && value !== undefined) {
                    value = value[valueKey];
                } else {
                    value = null;
                }
            }
        }
        return value;
    }

    optionValueParser = () => {
        let value = this.props.value;
        const valueKey = this.props.valueKey || this.state.valueKey;
        if (this.props.isMulti) {
            if (!Array.isArray(value)) {
                if (value) {
                    value = [value];
                } else {
                    value = [];
                }
            }
            if (value.length) {
                if (typeof (value[0]) !== "object") {
                    value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).filter((option) => value.find((v) => v + "" === "" + option[valueKey]));
                }
            }
            return value === undefined ? [] : value;
        } else {
            if ( ! (value instanceof Object)) {
                value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).find((option) => option[valueKey] + "" === "" + value);
            } else if(value instanceof Object && value[valueKey] !== undefined) {
                value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).find((option) => option[valueKey] + "" === "" + value[valueKey]);
            }
            return value === undefined ? null : value;
        }
    }

    focus = () => {

    }

    render() {
        const valueKey = this.props.valueKey || this.state.valueKey;
        const labelKey = this.props.labelKey || this.state.labelKey;
        let value = this.optionValueParser();
        /*if (Array.isArray(value)) {
            value = value.map((v) => v !== null && v !== undefined && typeof v === "object" ? v[valueKey] : v);
        } else if (value !== null && value !== undefined && typeof value === "object") {
            value = value[valueKey];
        }*/
        let options = this.props.options || this.state.options;
        const optionsTemplate = this.getOptionsTemplate();

        options = [...options];

        let style = {};
        if (this.props.label === false) {
            style.display = "none";
        }

        const objectValue = this.props.objectValue === undefined || this.props.objectValue === true;

        return <Fragment>
            <label
                htmlFor={this.props.name}
                className="control-label"
                style={style}
            >
                {this.props.label} {this.props.required && <span className="invalid-feedback">*</span>}
            </label>
            <div className={classNames("radiogroup react-checkbox-group", this.props.className, {"is-invalid": this.props.error})}>
                {options.map((option, optionIndex) => {
                    const optionValue = get(option, valueKey);
                    const values = value.map((option) => get(option, valueKey));
                    const valueIndex = values.indexOf(optionValue);
                    let disabled = false;
                    if (this.props.disabled) {
                        disabled = true;
                    } else if (this.props.disabledKey) {
                        disabled = option && typeof option === "object" && get(option, this.props.disabledKey);
                    } else if (this.props.disableOption instanceof Function) {
                        disabled = this.props.disableOption({
                            ...this.props,
                            options,
                            value,
                            option: value[valueIndex],
                            optionIndex: valueIndex,
                            checked: valueIndex !== -1,
                        });
                    }
                    const saveChanges = () => {
                        let newValues;
                        if (this.props.isMulti) {
                            newValues = [...value];
                            if (valueIndex === -1) {
                                newValues = [...value, objectValue ? option : optionValue];
                            } else {
                                newValues.splice(valueIndex, 1);
                            }
                        } else {
                            newValues = objectValue ? option : optionValue;
                        }
                        this.handleChange(newValues);
                    };
                    let checkbox = <CheckBox
                        name={this.props.name}
                        type="option"
                        value={value[valueIndex]}
                        checked={valueIndex !== -1}
                        label={get(option, labelKey)}
                        disabled={disabled}
                        saveChanges={saveChanges}
                    />
                    if (optionsTemplate instanceof Function) {
                        return <this.props.optionsTemplate
                            key={optionIndex}
                            {...this.props}
                            disabled={disabled}
                            value={value}
                            option={value[valueIndex]}
                            options={options}
                            optionIndex={valueIndex}
                            checked={valueIndex !== -1}
                            checkbox={checkbox}
                            saveChanges={saveChanges}
                        />;
                    } else if (optionsTemplate?.type) {
                        return <this.props.optionsTemplate.type
                            key={optionIndex}
                            {...optionsTemplate.props}
                            {...this.props}
                            disabled={disabled}
                            value={value}
                            option={value[valueIndex]}
                            options={options}
                            optionIndex={valueIndex}
                            checked={valueIndex !== -1}
                            checkbox={checkbox}
                            saveChanges={saveChanges}
                        />
                    }
                    return <Fragment key={optionIndex}>
                        {checkbox}
                    </Fragment>
                })}
            </div>
            {this.props.error && <div className="invalid-feedback">{this.props.error}</div>}
        </Fragment>;
    }

}

const TargetConfig = (props) => {
    const comp = <SelectComp ref={props.innerRef} {...props} />;
    if (props.componentConfig.target) {
        return <ComponentConfig componentName={props.componentConfig.target} componentConfigAs="targetConfig">
            {comp}
        </ComponentConfig>
    }
    return comp;
}

const Select = React.forwardRef((props, ref) => {
    if (props.component) {
        return <ComponentConfig componentName={props.component}>
            <TargetConfig innerRef={ref} {...props} />
        </ComponentConfig>
    } else {
        return <SelectComp ref={ref} {...props} />;
    }
});

Select.propTypes = {
    storeType: PropTypes.oneOf(["local", "remote"]).isRequired,
    saveChanges: PropTypes.func,
    onSelect: PropTypes.func,
    valueKey: PropTypes.string,
    labelKey: PropTypes.string,
    optionsTemplate: PropTypes.func,
    selectedOptionTemplate: PropTypes.func,
    disabledKey: PropTypes.string,
    matchmode: PropTypes.string,
    component: PropTypes.string,
    listfield: PropTypes.string,
    optionname: PropTypes.string,
    optioncomponent: PropTypes.string,
    isLoading: PropTypes.bool,
    placeholder: PropTypes.string,
    isClearable: PropTypes.bool,
    isMulti: PropTypes.bool,
    minLength: PropTypes.number,
    options: PropTypes.array,
    limit: PropTypes.number,
    filter: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    order: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    groupBy: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    parameters: PropTypes.object,
    value: PropTypes.any,
    label: PropTypes.any,
    required: PropTypes.bool,
    disabled: PropTypes.any,
    readOnly: PropTypes.any,
    error: PropTypes.any,
    name: PropTypes.string,
    createOptionPosition: PropTypes.oneOf(["first", "last"]),
    formatCreateLabel: PropTypes.func,
    objectValue: PropTypes.bool,
    isOptionDisabled: PropTypes.func,
    view: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    onLoadCompleted: PropTypes.func,
    onInputValueChanged: PropTypes.func,
    className: PropTypes.any,
    openIfHasOptions: PropTypes.bool,
};

export default Select;
